<template>
  <div>
    <v-row>
      <v-col cols="12" md="6">
        <v-card outlined rounded="lg">
          <div class="d-flex pt-2 px-3 pb-0 justify-space-between align-end">
            <div>
              <span>Dia com mais acessos</span>
              <h3 class="mb-0 text-capitalize">
                {{ reducedByWeekDay.mostLoggedDay[0] }}
              </h3>
            </div>
            <h4>{{ reducedByWeekDay.mostLoggedDay[1] }} acessos</h4>
          </div>
          <apexchart
            width="100%"
            height="110"
            class="series-chart"
            type="area"
            style="margin-bottom: -10px !important"
            :options="reducedByWeekDay.options"
            :series="reducedByWeekDay.series"
          ></apexchart>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card outlined rounded="lg">
          <div class="d-flex pt-2 px-3 pb-0 justify-space-between align-end">
            <div>
              <span>Horário com mais acessos</span>
              <h3 class="mb-0 text-capitalize">
                {{ reducedByHour.mostLoggedDay[0] }}
              </h3>
            </div>
            <h4>{{ reducedByHour.mostLoggedDay[1] }} acessos</h4>
          </div>
          <apexchart
            width="100%"
            height="120"
            class="series-chart"
            type="area"
            style="
              margin-bottom: -10px !important;
              margin-top: -10px !important;
            "
            :options="reducedByHour.options"
            :series="reducedByHour.series"
          ></apexchart>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  name: "LogsHighlight",
  props: {
    logs: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      defaultOptions: {
        // make minimalist
        stroke: {
          curve: "smooth",
        },
        chart: {
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        sparkline: {
          enabled: false,
        },
        grid: {
          show: true,
          xaxis: {
            lines: {
              show: true,
            },
          },
          yaxis: {
            lines: {
              show: false,
            },
          },
        },
        title: {
          show: false,
        },
        legend: {
          show: false,
        },
        tooltip: {
          enabled: false,
        },
        yaxis: {
          show: false,
        },
        yaxis: {
          max: function (max) {
            return max * 0.89;
          },
          labels: {
            show: false,
          },
        },
      },
    };
  },
  computed: {
    reducedByWeekDay() {
      const reduced = this.logs.reduce(
        (acc, log) => {
          if (log.type !== "ACCESS") return acc;
          const weekDay = dayjs(log.eventDate).format("ddd");
          acc[weekDay] = (acc[weekDay] || 0) + 1;
          return acc;
        },
        {
          dom: 0,
          seg: 0,
          ter: 0,
          qua: 0,
          qui: 0,
          sex: 0,
          sab: 0,
        }
      );

      const sorted = Object.entries(reduced).sort((a, b) => b[1] - a[1]);
      return {
        mostLoggedDay: sorted[0],
        lessLoggedDay: sorted[sorted.length - 1],
        options: {
          ...this.defaultOptions,
          tooltip: {
            enabled: true,
          },
          xaxis: {
            position: "top",
            labels: {
              show: true,
            },
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
            tooltip: {
              enabled: false,
            },
            categories: Object.keys(reduced),
          },
        },
        series: [
          {
            name: "Registros",
            data: Object.values(reduced),
          },
        ],
      };
    },
    reducedByHour() {
      const reduced = this.logs.reduce((acc, log) => {
        if (log.type !== "ACCESS") return acc;
        const hour = dayjs(log.eventDate).format("HH") + "h";
        acc[hour] = (acc[hour] || 0) + 1;
        return acc;
      }, Object.fromEntries(Array.from({ length: 24 }, (_, i) => [i.toString() + "h", 0])));

      const sorted = Object.entries(reduced).sort((a, b) => b[1] - a[1]);
      return {
        mostLoggedDay: sorted[0],
        lessLoggedDay: sorted[sorted.length - 1],
        options: {
          ...this.defaultOptions,
          tooltip: {
            enabled: true,
          },
          xaxis: {
            position: "top",
            labels: {
              show: false,
            },
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
            tooltip: {
              enabled: false,
            },
            categories: Object.keys(reduced),
          },
        },
        series: [
          {
            name: "Registros",
            data: Object.values(reduced),
          },
        ],
      };
    },
  },
};
</script>
<style scoped>
.series-chart {
  min-height: 100px !important;
}
</style>
